import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  animations: [
    trigger('divState', [
      state('moved', style({
        opacity: '1'
      },
      )),
      
      transition('void => *', [style({ opacity: 0, }), animate(200)]),
    ]),



  ]
})
export class LoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
